import { render, staticRenderFns } from "./IconChibis.vue?vue&type=template&id=5d714f10&"
import script from "./IconChibis.vue?vue&type=script&lang=js&"
export * from "./IconChibis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports